<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Hospice Eligibility Assessment — Big Bend Hospice</title>
    <meta name="theme-color" content="#3B7A6A" />
    <link rel="manifest" href="/manifest.webmanifest" />
    <link rel="icon" href="/favicon.ico" sizes="48x48" />
    <link rel="apple-touch-icon" href="/icons/apple-touch-icon.png" />
    <meta name="apple-mobile-web-app-title" content="BBH Eligibility" />
    <link rel="stylesheet" href="/src/style.css" />
  </head>
  <body>
    <div id="app"></div>
    <footer class="app-help" role="contentinfo">
      <p>Questions? Call Big Bend Hospice at <a href="tel:+18508785310">(850) 878-5310</a>.</p>
      <div id="install-slot"></div>
    </footer>
    <script type="module" src="/src/main.ts"></script>
  </body>
</html>
